export default __webpack_public_path__ + "static/media/IsidoraLovelace.cdffc6d5.png";